import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import InternalService from '../../../services/internal-api';
import './number-search.css';

export default function NumberSearchForm() {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [specimens, setSpecimens] = useState([]);
  const data = new InternalService();

  useEffect(() => {
    data.getSpecimenNumbers()
    .then((body) => {
      setSpecimens(body.data);
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const match = inputValue.match(/^\d{5}$/);
    if (inputValue.trim() === '') {
        setError("Write number in the format SAR, #####");
        return;
      }
    if (match) {
      const selectedId = Number(match[0]);
      console.log(specimens)
      const selected = specimens.find(specimen => specimen.id == selectedId);
      console.log(selectedId)

      if (selected) {
        const { idObv, idRev } = selected;
        navigate(`/type/${idObv}/${idRev}/${selectedId}`);
      }
      else 
      setError(
            <>
              Specimen is not found. Please try to select from the pre-defined set of values in <a href="/about">the old selector</a>.
            </>
      );
          } else {
      setError("Wrong type reference format, please try ##### (five digits)");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="type-search-form">
  <input
    type="text"
    placeholder="SAR, 11001"
    value={inputValue}
    onChange={(e) => {
      setInputValue(e.target.value);
      setError("");
    }}
    className="type-search-input"
  />
  {error && (
    <div className="type-search-error">{error}</div>
  )}
  <button type="submit" className="toggle-button">
    Go
  </button>
</form>
  );
}
